(function(){
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="goobs-cta-"].goobs-cta').forEach(function(root){

      // keyboard press feedback for CTA + icons
      root.addEventListener('keydown', (e)=>{
        if(e.key===' '||e.key==='Enter'){
          const btn = e.target.closest('.gh-cta, .gh-icon-btn');
          if(btn) btn.classList.add('is-pressed');
        }
      });
      root.addEventListener('keyup', (e)=>{
        const btn = e.target.closest('.gh-cta, .gh-icon-btn');
        if(btn) btn.classList.remove('is-pressed');
      });

      // mouse/touch press feedback
      root.querySelectorAll('.gh-cta, .gh-icon-btn').forEach((btn)=>{
        ['mousedown','touchstart'].forEach(ev=>btn.addEventListener(ev,()=>btn.classList.add('is-pressed')));
        ['mouseup','mouseleave','touchend','touchcancel'].forEach(ev=>btn.addEventListener(ev,()=>btn.classList.remove('is-pressed')));
      });
    });
  });
})();


import { animate } from "https://cdn.jsdelivr.net/npm/motion@10/+esm";

(function () {
  const MQ_MOBILE = "(max-width:680px)";
  const START_T = 0.4;     // 40% progress at first paint (from center -> final)
  const VIS_START = 0.60;  // start driving when 60% of section is visible
  const VIS_END   = 0.95;  // treat this as "completed"
  const SMOOTH_ALPHA = 0.12;
  const UNLOCK_EPS = 0.01; // little hysteresis so we don't flicker around VIS_END

  // Small utils
  const pct = (v) => {
    const n = parseFloat(String(v).replace("%", ""));
    return Number.isFinite(n) ? n : 50;
  };
  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  // === PRESS FEEDBACK (unchanged) ===
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[id^="goobs-cta-"].goobs-cta').forEach(function (root) {
      root.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          const btn = e.target.closest(".gh-cta, .gh-icon-btn");
          if (btn) btn.classList.add("is-pressed");
        }
      });
      root.addEventListener("keyup", (e) => {
        const btn = e.target.closest(".gh-cta, .gh-icon-btn");
        if (btn) btn.classList.remove("is-pressed");
      });

      root.querySelectorAll(".gh-cta, .gh-icon-btn").forEach((btn) => {
        ["mousedown", "touchstart"].forEach((ev) =>
          btn.addEventListener(ev, () => btn.classList.add("is-pressed"))
        );
        ["mouseup", "mouseleave", "touchend", "touchcancel"].forEach((ev) =>
          btn.addEventListener(ev, () => btn.classList.remove("is-pressed"))
        );
      });
    });
  });

  // === STICKER SCROLL ANIMATIONS (direction-aware locking) ===
  function setupStickers(root) {
    const prefersReduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const isMobile = matchMedia(MQ_MOBILE).matches;
    const stickers = root.querySelectorAll(".gh-sticker");
    if (!stickers.length) return;

    // --- MOBILE: snap to final mobile vars and bail (no listeners, no Motion) ---
    if (isMobile) {
      stickers.forEach((sticker) => {
        const cs = getComputedStyle(sticker);
        const xFinalPct = pct(cs.getPropertyValue("--m-x").trim() || "50%");
        const yFinalPct = pct(cs.getPropertyValue("--m-y").trim() || "50%");
        sticker.style.left = xFinalPct + "%";
        sticker.style.top  = yFinalPct + "%";
        sticker.dataset.motionInit = "1";
      });
      return; // <- do not activate on mobile
    }

    // Desktop below
    const ctrls = [];
    stickers.forEach((sticker) => {
      if (sticker.dataset.motionInit === "1") return;
      sticker.dataset.motionInit = "1";

      const cs = getComputedStyle(sticker);
      const xFinalPct = pct(cs.getPropertyValue("--x").trim() || "50%");
      const yFinalPct = pct(cs.getPropertyValue("--y").trim() || "50%");

      const xStart = 50 + (xFinalPct - 50) * START_T;
      const yStart = 50 + (yFinalPct - 50) * START_T;

      sticker.style.left = xStart + "%";
      sticker.style.top  = yStart + "%";

      if (prefersReduced) {
        sticker.style.left = xFinalPct + "%";
        sticker.style.top  = yFinalPct + "%";
        return;
      }

      const controls = animate(
        sticker,
        { left: [xStart + "%", xFinalPct + "%"], top: [yStart + "%", yFinalPct + "%"] },
        { duration: 1, easing: "linear" }
      );
      controls.pause();
      controls.currentTime = START_T;
      ctrls.push(controls);
    });

    if (!ctrls.length || prefersReduced) return;

    // Track scroll direction
    let lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    let targetT = START_T;
    let currentT = START_T;
    let rafId = null;
    let hasCompleted = false;

    const computeTargetFromVisibility = () => {
      const nowY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const dirDown = nowY > lastScrollY;
      lastScrollY = nowY;

      const vh = window.innerHeight;
      const r = root.getBoundingClientRect();

      const visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      const visFrac = clamp01(visible / Math.min(vh, r.height));

      if (hasCompleted) {
        if (dirDown) {
          targetT = 1;
          return;
        } else {
          if (visFrac < (VIS_END - UNLOCK_EPS)) {
            hasCompleted = false;
          } else {
            targetT = 1;
            return;
          }
        }
      }

      if (visFrac <= VIS_START) {
        targetT = START_T;
        return;
      }
      if (visFrac >= VIS_END) {
        targetT = 1;
        hasCompleted = true;
        return;
      }

      let seg = (visFrac - VIS_START) / (VIS_END - VIS_START);
      seg = clamp01(seg);
      const eased = easeOutCubic(seg);
      targetT = START_T + (1 - START_T) * eased;
    };

    const tick = () => {
      currentT = lerp(currentT, targetT, SMOOTH_ALPHA);
      for (const c of ctrls) c.currentTime = currentT;
      if (Math.abs(currentT - targetT) > 0.0005) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    };

    const onScrollOrResize = () => {
      // If the viewport becomes mobile after a resize, teardown & snap.
      if (matchMedia(MQ_MOBILE).matches) {
        window.removeEventListener("scroll", onScrollOrResize);
        window.removeEventListener("resize", onScrollOrResize);
        // Snap to mobile finals now:
        stickers.forEach((sticker) => {
          const cs = getComputedStyle(sticker);
          const xFinalPct = pct(cs.getPropertyValue("--m-x").trim() || "50%");
          const yFinalPct = pct(cs.getPropertyValue("--m-y").trim() || "50%");
          sticker.style.left = xFinalPct + "%";
          sticker.style.top  = yFinalPct + "%";
        });
        return;
      }
      computeTargetFromVisibility();
      if (rafId == null) rafId = requestAnimationFrame(tick);
    };

    // initial frame
    computeTargetFromVisibility();
    onScrollOrResize();

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
  }

  function initAll() {
    document.querySelectorAll('[id^="goobs-cta-"].goobs-cta').forEach(setupStickers);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Re-init on resize; honors the mobile short-circuit above.
  window.addEventListener("resize", () => {
    document
      .querySelectorAll('[id^="goobs-cta-"].goobs-cta .gh-sticker')
      .forEach((el) => (el.dataset.motionInit = ""));
    initAll();
  });
})();